import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Switch from "react-switch";
import { ManualDisableModal } from "./ManualDisableModal";
import { MenuDisableModal } from "./MenuDisableModal";
import {useUpdateMenuStatus} from "../../network";
import {FormField} from "../../components/FormField";
import {useTranslation} from "react-i18next";

export const MenuListSwitch = ({ item , isDisabled }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [openManualDisable, setOpenManualDisable] = useState(false);
    const { mutate: updateStatus, isLoading } = useUpdateMenuStatus()
    const handleChangeElement = (id, checked) => {
        updateStatus({slug: id, body: { status: checked? "active": "inactive" }})
    };

    const { type } = item;
    const isPos = type === "pos";

    const handleChange = (checked) => {
        !checked && setOpen(true);
        checked && isPos && setOpenManualDisable(true);
        checked && !isPos && handleChangeElement(item.id, checked);
        setIsChecked(checked)

    };

    const onSave = () => {
        handleChangeElement(item.id, isChecked);
        // dispatch(onMenuDisable(item.id));
        //isPos && dispatch(onPOSDeactivate(item.id));
        onClose();
    };

    const onManualSave = () => {
        handleChangeElement(item.id, isChecked);
        // dispatch(onPOSActivate(item.id));
        setOpenManualDisable(false);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onManualDisableClose = () => {
        setOpenManualDisable(false);
    };

    return (
        <>
            <FormField disabled={item.status === "archived"} popoverText={t("menu is archived")} popoverStyle={{ left: -40 }}>
                <Switch
                    onChange={handleChange}
                    checked={item.status === "active"}
                    onColor="#7f56d9"
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={24}
                    width={44}
                    disabled={!isPos && isDisabled || isLoading || item.status === "archived"}
                />
            </FormField>

            <MenuDisableModal
                visible={open}
                onClose={onClose}
                onSave={onSave}
            />

            <ManualDisableModal
                visible={openManualDisable}
                onClose={onManualDisableClose}
                onSave={onManualSave}
            />
        </>
    );
};
